import { render, staticRenderFns } from "./SearchIDard.vue?vue&type=template&id=19ad7b4f"
import script from "./SearchIDard.vue?vue&type=script&lang=js"
export * from "./SearchIDard.vue?vue&type=script&lang=js"
import style0 from "./SearchIDard.vue?vue&type=style&index=0&id=19ad7b4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports